import { makeStyles } from '@material-ui/core';

export const InstalmentsSelectStyle = makeStyles(({ breakpoints }) => ({
    root: {
        [breakpoints.up('sm')]: {
            width: '240px',
        },
    },
}));
